import { PrimaryButton } from '../../../../../../components/execution/PrimaryButton'
import { EventNames } from '../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../utils/appBridge'
import { PlansSipListEventIds, PlansSipListScreenByPlanMode } from '../../../analytics/plansEvents'
import { PlansErrorStateLayout } from '../../../ui/PlansErrorStateLayout'
import { SipPlanMode } from '../../api/types'

type SipPlansListErrorStateProps = {
  planMode: SipPlanMode
  onRetry: () => void
}

const SIP_LIST_ERROR_STATE_CONFIG: Record<SipPlanMode, { description: string; accentColor: string }> = {
  [SipPlanMode.YOUR_PLAN]: {
    description: "We couldn't load your SIP plan right now.",
    accentColor: '#7048AC'
  },
  [SipPlanMode.IDEAL_SIPS]: {
    description: "We couldn't load your ideal SIPs right now.",
    accentColor: '#2e8ae5'
  }
}

export function SipPlansListErrorState({ planMode, onRetry }: SipPlansListErrorStateProps) {
  const errorStateConfig = SIP_LIST_ERROR_STATE_CONFIG[planMode]

  return (
    <PlansErrorStateLayout className="bg-white">
      <svg
        viewBox="0 0 221 172"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        className="block h-auto w-full max-w-[221px]"
      >
        <circle cx="110.5" cy="86" r="40" stroke={errorStateConfig.accentColor} strokeWidth="3" />
        <path
          d="M110.5 68.5V96.5"
          stroke={errorStateConfig.accentColor}
          strokeWidth="4"
          strokeLinecap="round"
        />
        <circle cx="110.5" cy="106.5" r="3.5" fill={errorStateConfig.accentColor} />
      </svg>

      <div className="flex flex-col gap-3 items-center">
        <div className="text-[22px] font-[500] leading-[130%] text-[#232323]">Something went wrong</div>
        <div className="max-w-[219px] text-center text-[13px] font-[400] leading-[140%] text-[#6A6E6E]">
          {errorStateConfig.description} Please try again.
        </div>
        <PrimaryButton
          label="Retry"
          onClick={() => {
            trackEvent({
              eventName: EventNames.ButtonTap,
              payload: {
                ScreenName: PlansSipListScreenByPlanMode?.[planMode],
                eventId: PlansSipListEventIds.ListRetry,
                buttonLabel: 'Retry'
              }
            })
            onRetry()
          }}
          primaryButtonClassName="!h-10 !w-[140px] !mt-5"
        />
      </div>
    </PlansErrorStateLayout>
  )
}
